import Vue from 'vue';
import Router from 'vue-router';
import system from "./list";
Vue.use(Router);
// 解决连续点击同一个路由的抛出错误 catch捕获
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let routes = [
{
    path: '/',
    name: 'login',
    meta: {
      title: 'WETRUE',
      isLogin: false,
      isKeeplive: false,
      zIndex: 1,
    },
    component: () => import('@/pages/system/login.vue'),
  }, {
    path: '/login',
    name: 'login',
    meta: {
      title: 'WETRUE',
      isLogin: false,
      isKeeplive: false,
      zIndex: 1,
    },
    component: () => import('@/pages/system/login.vue'),
  },
  {
    path: '/weRexLogin',
    name: 'login',
    meta: {
      title: 'WETRUE',
      isLogin: false,
      isKeeplive: false,
      zIndex: 1,
    },
    component: () => import('@/pages/system/weRexLogin.vue'),
  },
  {
    path: '/system',
    name: 'system',
    meta: {
      title: 'WETRUE',
      isLogin: false,
      isKeeplive: false,
      zIndex: 1,
    },
    component: () => import('@/pages/system/system.vue'),
    children: [...system]
  },{
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/pages/agreementService/agreement.vue'),
    meta: {
      title: 'WETRUE用户协议',
      isLogin: false,
      isKeeplive:false,
      zIndex: 2,
    },
  }, {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/pages/agreementService/privacy.vue'),
    meta: {
      title: 'WETRUE用户隐私政策',
      isKeeplive:false,
      isLogin: false,
      zIndex: 2,
    },
  },
]
const ctx = require.context('./', true, /\.js$/);
let routeList = [];
for (const key of ctx.keys()) {
  if (ctx(key).default) {
    routeList = routeList.concat(ctx(key).default);
  }
}
routes = routes.concat(routeList);
export default new Router({
  base: '/',
  mode: 'history',
  routes: routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js